<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <p class="eyebrow">Contra Voucher</p>
        <div class="header-title-row">
          <h2>Finance Contra Voucher Preview</h2>
          <div class="toolbar" aria-label="Contra voucher actions">
            <mat-slide-toggle
              class="sign-toggle"
              color="primary"
              [checked]="includeSignature"
              (change)="onSignatureToggle($event.checked)">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Voucher
            </button>

            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img
              *ngIf="previewData.logo; else logoFallback"
              [src]="previewData.logo"
              alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Finance Department</div>
            <h1>{{ previewData.companyName | uppercase }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">CONTRA VOUCHER</div>
            <p><strong>Voucher No:</strong> {{ previewData.voucherNo }}</p>
            <p><strong>Voucher Date:</strong> {{ previewData.voucherDate }}</p>
            <p><strong>Reference No:</strong> {{ previewData.referenceNo }}</p>
            <p><strong>Reference Date:</strong> {{ previewData.referenceDate }}</p>
          </div>
        </div>

        <div class="po-overview">
          <div class="overview-card" *ngFor="let card of previewData.overview">
            <span class="overview-label">{{ card.label }}</span>
            <strong>{{ card.value }}</strong>
          </div>
        </div>

        <div class="section-block" *ngIf="previewData.hasDetailRows">
          <h3>Contra Details</h3>
          <table class="items-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>LEDGER</th>
                <th>BRANCH</th>
                <th>ENTRY TYPE</th>
                <th>DEBIT AMOUNT</th>
                <th>CREDIT AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData.detailRows">
                <td class="center">{{ row.sr }}</td>
                <td>{{ row.ledgerName }}</td>
                <td>{{ row.branchName }}</td>
                <td class="center">{{ row.entryType }}</td>
                <td class="right">{{ row.debitAmount }}</td>
                <td class="right">{{ row.creditAmount }}</td>
              </tr>
              <tr class="grand-row">
                <td colspan="4" class="right">TOTAL</td>
                <td class="right">{{ previewData.totalDebit }}</td>
                <td class="right">{{ previewData.totalCredit }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bottom-grid">
          <div class="details-block">
            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
            <section *ngIf="previewData.remarks !== '-'">
              <h3>Remarks</h3>
              <p>{{ previewData.remarks }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="html-sign-area">
              <div class="sign-company">
                For {{ previewData.companyNameTitle }}
              </div>
              <div class="sign-assets" *ngIf="includeSignature">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || "Authorized Signatory" }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Page 1 of 1</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">
        {{
          includeSignature
            ? "Generating signed contra voucher preview..."
            : "Generating contra voucher preview..."
        }}
      </p>
    </div>
  </ng-template>
</div>
